import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';
import '../css/ConfirmDialog.css';

const ConfirmDialog = ({ show, onHide, onConfirm, title, message }) => {
  return (
    <Dialog
      open={show}
      onClose={onHide}
      aria-labelledby="confirm-dialog-title"
      className="confirm-dialog"
    >
      <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onConfirm} variant="contained" color="error">
          Oui
        </Button>
        <Button onClick={onHide} variant="outlined" color="primary">
          Non
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
